<template>
  <div class="winning-clue">
		<template v-if="isList">
			<van-search 
				v-model="value" 
				placeholder="请输入手机号或名称进行搜索" 
			/>
			<div class="tab-box">
				<div class="tab-item" 
					v-for="(item,index) in tabList" :key="index" 
					:class="{active: currentIndex == index}"
					@click="switchTab(index)"
				>
					{{item}}
				</div>
			</div>
			<refresh-list 
				style="margin-top: 2px;"
				:list='list'
				@onLoad="onLoad" 
				@onRefresh="init"
				ref="refreshList"
			>
				<van-collapse v-model="activeName" accordion>
					<van-collapse-item  :name="index" v-for="(item,index) in list" :key="index">
						<template #title>
							<div class="title-name">{{item.contactsName}}</div>
							<div class="title-phone">{{item.contactsPohone}}</div>
						</template>
						<div class="content">
							<div class="list">
								<span class="list-key">活动名称</span>
								<span class="list-value">{{item.activityName}}</span>
							</div>
							<div class="list">
								<span class="list-key">活动ID</span>
								<span class="list-value">{{item.activityId}}</span>
							</div>
							<div class="list">
								<span class="list-key">奖品</span>
								<span class="list-value">{{item.prizeName}}</span>
							</div>
							<div class="list">
								<span class="list-key">中奖时间</span>
								<span class="list-value">{{item.createdTime}}</span>
							</div>
							<div class="list">
								<span class="list-key">分享人</span>
								<span class="list-value">{{item.shareName}}</span>
							</div>
							<div class="list">
								<span class="list-key">核销人</span>
								<span class="list-value">{{item.exchangeName}}</span>
							</div>
							<div class="list">
								<span class="list-key">状态</span>
								<span class="list-value">{{item.status | status}}</span>
							</div>
						</div>
					</van-collapse-item>
				</van-collapse>
			</refresh-list>
		</template>
		<div v-else>
			<null-data />
		</div>
  </div>
</template>

<script>
import refreshList from '@/components/refresh-list/refresh-list'
import nullData from './null-data'
export default {
	components: {
		refreshList,
		nullData
	},
	data() {
		return {
			value: "",
			tabList: ['全部','待兑奖','已兑奖'],
			currentIndex: 0,
			activeName: '1',
			list:[],
			pageNum: 1,
			pageSize: 20,
			firstInto: true,
			isList: false
		}
	},
	watch: {
    value: {
      handler(value) {
        this.init() 
      }
    }
  },
	mounted() {
    this.init();
  },
	methods: {
		onLoad() {
      this.queryLotteryRecordPageList();
    },
		init() {
      this.pageNum = 1;
      this.list = [];
      this.queryLotteryRecordPageList();
    },
		switchTab(index) {
			this.currentIndex = index
			this.init()
		},
		queryLotteryRecordPageList() {
			let parmes = {
				filterData: {
					activityId: this.$route.query.activityId || '',
					status: this.currentIndex == 0 ? '' : this.currentIndex,
					text: this.value
				},
				pageNum: this.pageNum,
				pageSize: this.pageSize
			}
			this.$api.luckDraw.queryLotteryRecordPageList(parmes).then(res => {
				if (res.code == 200) {
					if (this.firstInto) {
						this.isList = res.data.list.length ? true : false
						this.firstInto = false
					}
					this.list.push(...res.data.list);
					this.pageNum = res.data.pageNum + 1;
					if(this.isList) this.$refs["refreshList"].complete(res.data);
				} else {
					if(this.isList) this.$refs["refreshList"].onFinish();
				}
			})
			.catch((err) => {
				this.$refs["refreshList"].onFinish();
			});
		}
	},
	filters: {
		status(type) {
			let map = {
				1: '待兑奖',
				2: '已兑换'
			}
			return map[type]
		}	
	}
}
</script>

<style lang="stylus" scoped>
	.winning-clue {
		.tab-box {
			display: flex;
			align-items: center;
			width: 100%;
			height: 44px;
			background: #fff;
			.tab-item {
				flex: 1
				text-align: center;
				line-height: 44px;
				color: #999999;
				border-right: 1px solid #E5E5E5;
			}
			.tab-item:last-child{
				border-right: none;
			}
			.active {
				color: #FF6B31;
				background: #FFF2ED;
			}
		}
		.title-name {
			font-size: 16px;
			color: #333333;
		}
		.title-phone {
			color: #999999;
			font-size: 13px;
		}
		.content {
			.list {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 14px;
				padding: 8px 0;
				.list-key {
					color: #999999;
				}
				.list-value {
					width: 66%;
					color: #333333;
					text-align: right;
				}
			}
		}
	}
</style>